// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"FJ-z","carouselContainer":"GJ-z"};